<template>
  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 13V9.4C21 7.15979 21 6.03968 20.564 5.18404C20.1805 4.43139 19.5686 3.81947 18.816 3.43597C17.9603 3 16.8402 3 14.6 3H7.4C5.15979 3 4.03968 3 3.18404 3.43597C2.43139 3.81947 1.81947 4.43139 1.43597 5.18404C1 6.03968 1 7.15979 1 9.4V12.6C1 14.8402 1 15.9603 1.43597 16.816C1.81947 17.5686 2.43139 18.1805 3.18404 18.564C4.03968 19 5.15979 19 7.4 19H13M8.5 8.00914V13.9908C8.5 14.8266 9.47486 15.2988 10.1482 14.7892L14.1004 11.7984C14.6332 11.3952 14.6332 10.6048 14.1004 10.2016L10.1482 7.21073C9.47486 6.70117 8.5 7.17341 8.5 8.00914Z" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <path d="M19 16V19M19 19V22M19 19H22M19 19H16" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>

<script>

export default {
  name: 'addVideoIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
